/* eslint-disable*/
import VueStoreService from './VueStoreService';
const QuoteService = {
    async getQuotes(url,store){
        var resp = await VueStoreService.get("quotes"+url, store)
        return resp;
    },
    async saveQuote(data,store){
        var resp = await VueStoreService.post("quote-detail",data,store)
        return resp;
    },
    async getQuoteById(quote_id,store){
        var resp = await VueStoreService.get("quote-detail/"+quote_id,store)
        return resp;
    },

    async updateQuote(quote_id,data,store){
        var resp = await VueStoreService.patch("quote-detail/"+quote_id,data,store)
        return resp;
    },

    async deleteQuote(quote_id,store){
        var resp = await VueStoreService.delete("quote-detail/"+quote_id,store)
        return resp;
    },
}

export default QuoteService;